import { useEffect, useState } from 'react'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'

import style from '@src/pages/Purchases/MyPurchases.module.scss'
import { Datepicker } from '@src/components/common/Datepicker/Datepicker'
import { selectIsLoading } from '@src/store/ducks/auth/selectors'
import { selectUserPurchases } from '@src/store/ducks/user/selectors'
import { AppDispatch } from '@src/store/store'
import { getPurchases } from '@src/store/ducks/user/thunks'
import { Buy } from '@src/components/Buy/Buy'
import { Button } from '@src/components/Button/Button'
import { resetPurchases, setResetField } from '@src/store/ducks/user/reducer'

// const PAGE_SIZE = 5

export const MyPurchases = () => {
  const dispatch = useDispatch<AppDispatch>()

  const isLoading = useSelector(selectIsLoading)
  const purchases = useSelector(selectUserPurchases)
  const [page, setPage] = useState(1)

  const [date, setDate] = useState({
    startDate: moment().subtract(1, 'months').format('DD.MM.YYYY'),
    endDate: moment().format('DD.MM.YYYY'),
  })

  useEffect(() => {
    dispatch(getPurchases(
      date.startDate, moment(date.endDate, 'DD.MM.YYYY').add(1, 'day').format('DD.MM.YYYY'), page,
    ))
  }, [date.endDate, date.startDate, dispatch, page])

  useEffect(() => () => {
    dispatch(resetPurchases())
  }, [dispatch])

  const showMore = () => {
    setPage(page + 1)
  }

  const handleSetDate = (newDate: any) => {
    dispatch(setResetField())
    setDate(newDate)
    setPage(1)
  }

  return (
    <div>
      <div className={style.selectContainer}>
        <Datepicker date={date} setDate={handleSetDate} maxDays={90} maxDate={moment().format()} />
      </div>
      {/* <Preloader center loading={isLoading}> */}
      <ul className={style.purchasesTable}>
        {purchases.content.length
          ? purchases.content.map((operation) => (
            <li className={style.operation} key={operation.number}>
              <Buy
                date={moment(operation.date, 'DD.MM.YYYY').format('DD.MM.YYYY')}
                number={operation.number}
                amount={operation.amount}
                awardBonus={operation.awardBonus}
                usedBonus={operation.usedBonus}
              />
            </li>
          )) : (
            <div className={style.message}>
              В данный период не производились операции по приобритению товара. Попробуйте выбрать другой диапазон дат.
            </div>
          )}
      </ul>
      {(purchases.more) && (
      <div className={style.btnContainer}>
        <Button
          className={style.btnSize}
          type="secondary"
          onClickFunc={() => showMore()}
          loading={isLoading}
        >
          Показать больше
        </Button>
      </div>
      )}
      {/* </Preloader> */}
    </div>
  )
}
